import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';
import type { FavoriteMarketsCategory } from 'shared/src/api/favoriteMarketService/getFavoriteMarketsFilterOptions/types';

type LogApplySortParams = {
  sortKey: string;
  category: FavoriteMarketsCategory | null;
};

export const useLogApplySort = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    ({ sortKey, category }: LogApplySortParams) => {
      logAnalyticsEvent({
        name: 'APPLY_SORT',
        analytics: {
          SORT_TYPE: sortKey,
          CATEGORY_NAME: category?.name ?? '전체',
          CATEGORY_SNO: category?.sno.toString() ?? '-1',
        },
      });
    },
    [logAnalyticsEvent],
  );
};
